module.exports = __webpack_public_path__ + "static/media/influencer.2b079c69.png";